import { render, staticRenderFns } from "./typesetting2.vue?vue&type=template&id=1107cd09&scoped=true&"
import script from "./typesetting2.vue?vue&type=script&lang=js&"
export * from "./typesetting2.vue?vue&type=script&lang=js&"
import style0 from "./typesetting2.vue?vue&type=style&index=0&id=1107cd09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107cd09",
  null
  
)

export default component.exports